import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { LayoutComponent } from 'app/layout/layout.component';
import { IsAuthenticatedGuard } from './core/auth/is-authenticated.guard';
import { RoleAuthGuard } from './core/auth/role-auth.guard';
import { SlugExistsGuard } from './core/auth/slug-exists.guard';
import { featureEnabledGuard } from './core/features/feature-enabled.guard';
import { Error404Component } from './modules/auth/error-404/error-404.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home',
    },
    {
        path: 'unauthorized',
        component: Error404Component,
    },
    {
        path: 'auth',
        loadChildren: () =>
            import('./core/auth/auth.module').then((m) => m.AuthModule),
    },
    {
        path: 'signed-in-redirect',
        pathMatch: 'full',
        redirectTo: 'auth',
    },
    {
        path: 'invitation/:orgId/:invitationId',
        component: LayoutComponent,
        canActivate: [IsAuthenticatedGuard],
        data: { layout: 'empty' },
        children: [
            {
                path: '',
                loadChildren: () =>
                    import('app/modules/invitation/respond/respond.routes'),
            },
        ],
    },
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'sign-out',
                loadChildren: () =>
                    import('app/modules/auth/sign-out/sign-out.routes'),
            },
            {
                path: 'sign-in',
                loadChildren: () =>
                    import('app/modules/auth/sign-in/sign-in.routes'),
            },
            {
                path: 'request-permission',
                loadChildren: () =>
                    import(
                        'app/modules/auth/request-permission/request-permission.routes'
                    ),
            },
            {
                path: 'survey/:id',
                loadComponent: () =>
                    import(
                        'app/modules/public/survey/public-survey.component'
                    ).then((m) => m.PublicSurveyComponent),
            },
        ],
    },
    {
        path: '',
        component: LayoutComponent,
        canActivate: [IsAuthenticatedGuard, RoleAuthGuard],
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'profile',
                loadChildren: () =>
                    import('app/modules/profile/profile.routes'),
            },
            {
                path: 'home',
                loadChildren: () =>
                    import('app/modules/landing/home/home.routes'),
            },
        ],
    },
    {
        path: ':slug',
        canActivate: [IsAuthenticatedGuard, RoleAuthGuard, SlugExistsGuard],
        data: { roles: ['creator'] },
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver,
        },
        children: [
            { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
            {
                path: 'dashboard',
                loadChildren: () =>
                    import(
                        'app/modules/admin/dashboard/analytics/analytics.routes'
                    ),
            },
            {
                path: 'events',
                loadChildren: () =>
                    import('app/modules/admin/apps/events/events.routes'),
            },
            {
                path: 'tickets',
                canActivate: [featureEnabledGuard],
                data: { feature: 'ticketing' },
                loadChildren: () =>
                    import('app/modules/admin/apps/ticketing/ticketing.routes'),
            },
            {
                path: 'feedback',
                canActivate: [featureEnabledGuard],
                data: { feature: 'surveys' },
                loadChildren: () =>
                    import('app/modules/admin/apps/feedback/feedback.routes'),
            },
            {
                path: 'organization',
                loadChildren: () =>
                    import(
                        'app/modules/admin/apps/organisation/organisation.routes'
                    ),
            },
            {
                path: 'settings',
                redirectTo: 'organization',
            },
            {
                path: 'audit-logs',
                loadChildren: () =>
                    import(
                        'app/modules/admin/apps/audit-logs/audit-logs.routes'
                    ),
            },
            {
                path: 'advertisements',
                loadChildren: () =>
                    import(
                        'app/modules/admin/apps/advertisements/advertisements.routes'
                    ),
            },
        ],
    },
];
